"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var ProjectActions = require("@caddigital/sok-reducers/lib/actions/projects");
var Icon_1 = require("components/Icon");
var Types = require("types");
var mapStateToProps = function (state) {
    return {
        showBookmarked: state.projects.showBookmarked,
        showArchived: state.projects.showArchived
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleShowBookmarks: function () { return dispatch(ProjectActions.toggleShowBookmarked()); },
    toggleShowArchived: function () { return dispatch(ProjectActions.toggleShowArchived()); },
    clearFilters: function () { return dispatch(ProjectActions.clearFilters()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('ProjectListSearch'), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'filters' },
    React.createElement(sok_ui_1.Dropdown2, null,
        React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('userFront/projectsTab/buttons/filter'), color: "dark-gray", border: 'yellow', icon: React.createElement(Icon_1.Icon, { key: "left", className: "fa-filter" }), iconRight: React.createElement(Icon_1.Icon, { key: "right", className: "fa-chevron-down" }) }),
        React.createElement(sok_ui_1.Dropdown2Menu, { className: 'project-list-filter-dropdown' },
            React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () { return props.toggleShowBookmarks(); } },
                React.createElement("span", null,
                    React.createElement(Icon_1.Icon, { prefix: 'far', className: props.showBookmarked ? 'fa-check-square' : 'fa-square' }),
                    (0, translation_1.getLocalization)('userFront/projectsTab/buttons/filter/showBoomarks'))),
            React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () { return props.toggleShowArchived(); } },
                React.createElement("span", null,
                    React.createElement(Icon_1.Icon, { prefix: 'far', className: props.showArchived ? 'fa-check-square' : 'fa-square' }),
                    (0, translation_1.getLocalization)('userFront/projectsTab/buttons/filter/showArchived'))))),
    React.createElement(sok_ui_1.Button, { onClick: props.clearFilters, color: 'blue', text: (0, translation_1.getLocalization)('userFront/projectsTab/buttons/clearFilters') }))); });
